<template>
    <div class="card-container">
        <common-top-form :model="formModel" :show="false" :submitService="submitService"
                         :submitData="submitData" @success="onSuccess">
            <select-organs v-model="formModel.tatSimpleId"></select-organs>
            <el-form-item label="真实姓名">
                <el-input type="text" maxlength="20" v-model="formModel.memName" placeholder="请输入真实姓名"></el-input>
            </el-form-item>
            <el-form-item label="电话">
                <el-input type="text" maxlength="20" v-model="formModel.memPhone" placeholder="请输入会员电话"></el-input>
            </el-form-item>
            <el-form-item label="卡号">
                <el-input type="text" maxlength="50" v-model="formModel.cardNo" placeholder="请输入卡号"></el-input>
            </el-form-item>
            <el-form-item label="使用状态" prop="deleteStatus">
                <el-select v-model="formModel.deleteStatus">
                    <el-option
                        v-for="item in deleteStatus"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="卡片类型" prop="cardType">
                <el-select v-model="formModel.cardType">
                    <el-option
                        v-for="item in cardTypes"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="创建时间">
                <el-date-picker
                    v-model="time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
        </common-top-form>
        <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
            <el-table-column prop="tatName" label="机构简称" min-width="100" show-overflow-tooltip :formatter="formatterTableData"></el-table-column>
            <el-table-column prop="userName" label="姓名" min-width="100" show-overflow-tooltip :formatter="formatterTableData"></el-table-column>
            <el-table-column prop="phone" label="电话" min-width="130">
                <!--<template slot-scope="scope">-->
                <!--<p>{{doUnicode(scope.row.phone)}}</p>-->
                <!--</template>-->
            </el-table-column>
            <!--<el-table-column prop="idCard" label="身份证号" min-width="100"></el-table-column>-->
            <el-table-column prop="cardNo" label="银行卡号" min-width="130" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p>{{doUnicode(scope.row.cardNo)}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="bankName" label="银行名称" min-width="100" show-overflow-tooltip :formatter="formatterTableData"></el-table-column>
            <el-table-column prop="cardType" label="卡片类型" min-width="100" show-overflow-tooltip :formatter="formatterCardType"></el-table-column>
            <el-table-column prop="billDate" label="账单区间" min-width="100" show-overflow-tooltip :formatter="formatterRange"></el-table-column>
            <el-table-column prop="deleteStatus" label="使用状态" min-width="100" show-overflow-tooltip :formatter="formatterdeleteStatus"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" min-width="160" :formatter="formatterTableData"></el-table-column>
        </common-table>
    </div>
</template>

<script>
    import CommonTopForm from 'components/common/CommonTopForm'
    import CommonTable from 'components/common/CommonTable'
    import SelectOrgans from 'components/business/SelectOrgans'

    import OrganService from 'service/OrganService'
    import TransactionService from 'service/TransactionService'
    import TimeRange from 'service/constant/TimeRange'
    import cardTypes from 'service/constant/CardTypes'
    import privateKey from 'service/constant/privateKey'
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";
    import {mapGetters} from 'vuex'

    export default {
        name: "creditcard",
        components: {
            CommonTopForm, CommonTable, SelectOrgans
        },
        data() {
            return {
                formModel: {
                    tatSimpleId: '',
                    cardNo: '',
                    memName: '',
                    memPhone: '',
                    idCard: '',
                    cardType: '',
                    deleteStatus: '',
                },
                tableData: [],
                all: [{
                    id: '',
                    simpleName: '全部'
                }],
                page: {},
                submitService: TransactionService.getCardCCs,
                isPage: false,
                time: TimeRange.dayRange,
                deleteStatus:[{
                    dictKey:'',
                    dictValue:'全部'
                },{
                    dictKey:'0',
                    dictValue:'使用中'
                },{
                    dictKey:'1',
                    dictValue:'已删除'
                }],
                cardTypes:cardTypes
            }
        },
        mounted() {
            this.page = this.$refs.commonTable.page;
            this.getList();
        },
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        computed: {
            submitData() {
                if (this.time == null || this.time == '') {
                    this.time = [];
                }
                const params = {
                    userId: this.userId,
                    tatSimpleId: this.formModel.tatSimpleId,
                    cardType: this.formModel.cardType,
                    deleteStatus: this.formModel.deleteStatus,
                    cardNo: this.formModel.cardNo.trim(),
                    memName: this.formModel.memName.trim(),
                    memPhone: this.formModel.memPhone.trim(),
                    idCard: this.formModel.idCard.trim(),
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };
                if (this.time.length) {
                    params.startDate = this.time[0];
                    params.endDate = this.time[1];
                }

                return params;
            },
            ...mapGetters(['serverType', 'tatId', 'userId'])
        },
        methods: {
            getPage() {
                this.isPage = true;
                this.getList();
            },
            getList() {
                this.doLoad(TransactionService.getCardCCs, this.submitData, res => {
                    this.doCheck(res, res => {
                        this.onSuccess(res);
                        this.isPage = false;
                    });
                }, '信息获取失败')
            },
            onSuccess(res) {
                this.doCheck(res, res => {
                    const result = res.contents;
                    this.tableData = result.records;
                    // console.log('result',this.tableData);

                    this.page.currentPage = result.current;
                    this.page.total = result.total;
                    this.page.pageSize = result.size;
                });
            },
            formatterdeleteStatus(row, column, cellValue, index){
                let value = '--';
                this.deleteStatus.forEach(item => {
                    if (item.dictKey == cellValue) {
                        value = item.dictValue
                    }
                });
                return value;
            },
            formatterCardType(row, column, cellValue, index){
                let value = '--';
                this.cardTypes.forEach(item => {
                    if (item.id == cellValue) {
                        value = item.label
                    }
                });
                return value;
            },
            formatterRange(row, column, cellValue, index){
                console.log(row, row.cardType == 1)
                let value = '--';
                if (row.cardType == 1) {
                    value = row.billDate + '-' + row.paymentDate
                }
                return value;
            }
        }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/page/TransactionManage/CreditCard.vue